import React, { useState, useMemo } from 'react';
import { Input } from 'semantic-ui-react';
import * as _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './LeftPanelGrid.module.css';
import { selectStop } from '../map/redux/actions';
import { STOP_TYPE } from '../map/constants';
import { CONTAINERS, resetView } from '../common/cardNavigationComponent/cardNavigationRedux';
import StopCard from '../common/stopCard/StopCard';

const getStopData = (state) => {
  const { stopsDict } = state.manageMapViewReducer;
  return Object.values(stopsDict).filter((stop) => stop.type !== STOP_TYPE.USER_CURRENT_LOCATION_STOP);
};

const LocationPane = ({ clearSelectedUser }) => {
  const [searchText, setSearchText] = useState('');
  const stopData = useSelector(getStopData);
  const selectedStopId = useSelector((state) => state.manageMapViewReducer.selectedStopId);
  const iframepresentState = useSelector((state) => state.taskViewPageReducer.iframepresentState);
  const filteredLocations = useMemo(() => {
    return stopData.filter((stop) => !searchText || stop.stopName.toLowerCase().includes(searchText.toLowerCase()));
  }, [searchText, stopData]);

  const dispatch = useDispatch();

  return (
    <div className={!iframepresentState ? styles.leftPanelSubContainer : styles.leftPanelSubContainerForIfram}>
      <Input
        icon="search"
        placeholder="Search"
        className={styles.searchInput}
        value={searchText}
        onChange={(event, { value }) => {
          setSearchText(value);
        }}
      />
      <div className={styles.listContainer}>
        {filteredLocations.map((location) => {
          return (
            <div
              key={location.stopId}
              className={location.stopId === selectedStopId ? styles.boxSelected : styles.box}
              onClick={(e) => {
                dispatch(selectStop(location.stopId, false));
                clearSelectedUser();
                dispatch(resetView(CONTAINERS.MAP_VIEW, { component: StopCard, props: { stopId: location.stopId } }));
                e.stopPropagation();
              }}
            >
              <div className={styles.boxHeader}>{location.stopName}</div>
              <div className={styles.stopsTasks}>
                <div className={styles.stopsTasksCount}>{_.get(location, 'taskList', []).length} Tasks</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

LocationPane.propTypes = {
  clearSelectedUser: PropTypes.func.isRequired,
};

export default LocationPane;
